<template>
    <div style="background-color: #1f2d3d" :style="{ height: this.screenHeight + 'px' }">
        <!-- <div class="openVoice" title="chrome浏览器限制自动触发语音播报" :class="{display:isHideOpenDiv}" >
      开启语音播报
    </div> -->
        <Board :rows="items" :span="3" v-cloak @init="loadConfig"></Board>
        <div class="message" :class="{ active: isHide }">
            <div class="patient_name">{{ message[0] }}</div>
            <div class="note">{{ message[1] }}</div>
        </div>
    </div>
</template>
vo
<script>
import axios from 'axios'
import Board from './Board'
import { mapGetters } from 'vuex'
export default {
    name: `BoardFamily`,
    components: { Board },
    props: {

    },
    data() {
        return {
            page: 1,
            load_timer: {},
            load_message: {},
            voice_timer: {},
            speakFinish: {},
            all_page: 1,
            message: [],
            noticeDatas: [],
            items: [],
            config: {},
            msg: ``,
            boardConfigPageInterval: 10,
            boardConfigAudio: 1,
            boardConfigFamilyPrivate: true,
            boardConfigRemainBuffer: 0.5,
            isHide: true,
            // isHideOpenDiv:false,
            token: sessionStorage.getItem(`token`),
            headers: [
                {
                    dic_operating_room: {
                        label: `手术间`,
                        span: 3
                    },
                    dic_section: {
                        label: `申请科室`,
                        span: 3
                    },
                    patient_name: {
                        label: `病人姓名`,
                        span: 3
                    },
                    bed_no: {
                        label: `床号`,
                        span: 3
                    },
                    age: {
                        label: `年龄`,
                        span: 3
                    },
                    surgeries: {
                        label: `手术名称`,
                        span: 5
                    },
                    surgery_status: {
                        label: `状态`,
                        span: 3
                    }
                }],
            dic_operating_room: undefined,
            role_ids: [],
            username: ``,
            roomIds: this.$route.query.roomIds && this.$route.query.roomIds.split(`,`) || [],
            bedIds: this.$route.query.bedIds && this.$route.query.bedIds.split(`,`) || []
        }
    },
    created() {
        // this.$store.dispatch("ADD_CURRENTUSER")
        this.init().then((data) => {
            this.voiceTimer()
        })
    },
    computed: {
        ...mapGetters([`screenHeight`, `active_ward`, `ward_auth`, `currentUser`]),
        user() {
        // this.username = this.currentUser&&this.currentUser.username
            return this.currentUser && this.currentUser.username
        }
    },
    mounted() {
        if (this.load_timer) {
            clearInterval(this.load_timer)
        }
        if (this.speakFinish) {
            clearInterval(this.speakFinish)
        }
        if (this.voice_timer) {
            clearInterval(this.voice_timer)
        }
        this.loadFamilyList()
        this.timer()
        this.reseveMessage()
    },
    methods: {
        init() {
            return new Promise((resolve) => {
                let req = this.myaxios.get(`/api/AcisSystem/Config/Get`)
                let req1 = this.$store.dispatch(`ADD_CURRENTUSER`).then(() => {
                    return this.myaxios.get(`api/AcisSystem/SysUser/GetRegions?username=${this.user}`)
                })
                this.myaxios.all(req, req1).then(([data, data1]) => {
                    this.role_ids = data1.operating_wards.map(d => {
                        return `ow_${d.id}`
                    })
                    this.boardConfigPageInterval = _.filter(data, { key: `BoardConfigPageInterval` })[0] && _.filter(data, { key: `BoardConfigPageInterval` })[0].value
                    this.boardConfigAudio = _.filter(data, { key: `BoardConfigAudio` })[0] && _.filter(data, { key: `BoardConfigAudio` })[0].value
                    this.hosptialName = _.filter(data, { key: `HospitalName` })[0] && _.filter(data, { key: `HospitalName` })[0].value
                    this.boardLineHeight = _.filter(data, { key: `BoardLineHeight` })[0] && _.filter(data, { key: `BoardLineHeight` })[0].value
                    resolve(this.role_ids)
                })
            })
        },
        reseveMessage() {
            let that = this
            let wsImpl = window.WebSocket || window.MozWebSocket
            window.ws = new wsImpl(this.$root.BoardIP)
            var heartCheck = {
                timeout: 60000, // 60ms
                timeoutObj: null,
                reset: function() {
                    clearTimeout(this.timeoutObj)
                    this.start()
                },
                start: function() {
                    this.timeoutObj = setTimeout(function() {
                        ws.send(`HeartBeat`)
                    }, this.timeout)
                }
            }
            ws.onmessage = function(evt) {
                heartCheck.reset()
                let data = JSON.parse(evt.data)
                console.log(`=====收到消息=====`, data)
                if (data.type === `DP`) {
                    that.noticeDatas.push(data)
                }
                if (that.active_ward.value !== data.receiver) {
                    return false
                }
            }
            ws.onopen = function() {
                heartCheck.start()
                console.log(`connection open`)
            }
            ws.onclose = function() {
                console.log(`connection closed`)
                setTimeout(function() {
                    that.reseveMessage()
                }, 5000)
            }
        },
        loadConfig(config) {
        },
        loadFamilyList() {
            let data = []
            return new Promise((resolve, reject) => {
                axios.post(`/api/Operation/BoardNotice/GetFamilyNoticeList`,
                    { page: this.page, roomIds: this.roomIds, beds: this.bedIds },
                    Object.assign({ headers: {
                        'Authorization': `bearer ${this.token}`
                    },
                    emulateJSON: true })).then((response) => {
                    if (response.status === 200) {
                        let r = _.map(response.data, (d) => {
                            return {
                                dic_operating_room: {
                                    label: d.dic_operating_room,
                                    span: 3
                                },
                                dic_opearting_ward: {
                                    label: d.dic_section,
                                    span: 3
                                },
                                patient_name: {
                                    label: d.patient_name,
                                    span: 3
                                },
                                bed_no: {
                                    label: d.bed_no,
                                    span: 3
                                },
                                age: {
                                    label: d.age,
                                    span: 3
                                },
                                surgeries: {
                                    label: (d.surgeries == null || d.surgeries === undefined) ? d.surgeries : `${d.surgeries.substring(0, 7)}...`,
                                    span: 5
                                },
                                surgery_status: {
                                    label: d.surgery_status,
                                    span: 3
                                }
                            }
                        })

                        this.all_page = response && response.other && response.other.all_page
                        this.page = this.page === this.all_page ? 1 : this.page + 1
                        data = this.headers.concat(r)
                        this.items = data
                        resolve(this.items)
                    } else {
                        return reject(response.msg)
                    }
                }).catch(e => {
                    if (e && e.data && e.status == `600`) {
                        ElementUI.Message.error(e.data && e.data.detail)
                    } else if (e && e.data) {
                        ElementUI.Notification.error({
                            title: `错误`,
                            message: e.data && `${e.data.detail}(timestamp:${e.data.timestamp})`
                        })
                    }
                    // return reject(e)
                })
            })
        },
        timer() {
            let that = this
            this.load_timer = setInterval(() => {
                if (this.isHide) {
                    this.loadFamilyList()
                }
            }, that.boardConfigPageInterval * 1000)
        },
        voiceTimer() {
            console.log(`=====计时器开始执行=======`)
            this.voice_timer = setInterval(() => {
                let r = this.noticeDatas[0]
                let recever = r && r.receiver || 0
                this.dic_operating_room = this.active_ward && this.active_ward.value
                let ids = _.filter(this.role_ids, d => {
                    return d == recever
                })
                if (this.noticeDatas.length != 0 && (r.receiver === this.dic_operating_room || ids.length != 0)) {
                    this.voiceBroadcast()
                } else {
                    this.noticeDatas.shift()
                }
            }, 10000)
        },
        voiceBroadcast() {
            console.log(`开始播报`)
            let synth = window.speechSynthesis
            let that = this
            that.message = that.noticeDatas[0].disaplayText.split(` `)
            let voices = synth.getVoices()
            if (synth.speaking) { return }
            that.isHide = false
            let utterThis = new SpeechSynthesisUtterance(that.noticeDatas[0].readText)

            for (let i = 0; i < voices.length; i++) {
                if (voices[i].lang == `zh-CN`) {
                    utterThis.voice = voices[i]
                    break
                }
            }
            utterThis.pitch = 1
            utterThis.rate = 0.8
            utterThis.volume = 1
            utterThis.onerror = function(event) {
                console.log(`请点击开启语音按钮`)
            }
            for (let i = 0; i < this.boardConfigAudio; i++) {
                synth.speak(utterThis)
            }
            that.speakFinish = setInterval(function() {
                if (!synth.speaking) {
                    console.log(`播报结束`)
                    that.isHide = true
                    that.noticeDatas.shift()
                    clearInterval(that.speakFinish)
                }
            }, 1000)
        }
        // hideOpenDiv(){
        //   this.isHideOpenDiv = true
        // }
    },
    destroyed() {
        clearInterval(this.load_timer)
        clearInterval(this.speakFinish)
        clearInterval(this.voiceTimer)
    },
    watch: {
        boardConfigPageInterval() {
            clearInterval(this.load_timer)
            this.timer()
        },
        user() {
            this.init()
        }
    //  role_ids(){
    //    clearInterval(this.voice_timer)
    //    this.voiceTimer()
    //  }
    //  username(){
    //    this.init()
    //  }
    }
}
</script>

<style scoped>
[v-cloak] {
    display: none !important;
}
.background {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #1f2d3d;
}
.message {
    position: fixed;
    top: 50%;
    left: 50%;
    width: 800px;
    height: 500px;
    color: #ffffff;
    background-image: linear-gradient(#ee0262, #650133);
    z-index: 999;
    border-radius: 10px;
    margin-top: -250px;
    margin-left: -400px;
    font-size: 64px;
}
.patient_name,
.note {
    height: 50%;
    line-height: 250px;
}
.active {
    display: none;
}
.openVoice {
    position: fixed;
    z-index: 99;
    text-align: center;
    left: 50%;
    top: 50%;
    color: #fff;
    cursor: pointer;
    font-size: 72px;
}
.display {
    display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Board/BoardFamily.vue